export const skeletonBaseColor = '#E0E0E0';
